import { StorageKeys } from './Storage.constants';
import { IStorage } from './Storage.types';

export class WebStorage implements IStorage {
  constructor() {}

  getItem(key: StorageKeys): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  setItem(key: StorageKeys, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  removeItem(key: StorageKeys): void {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }
}
